<!--颜色，没有ID和name-->
<template>
  <el-color-picker
    v-model="value"
    v-bind="$attrs"
  >
  </el-color-picker>
</template>

<script lang="ts">
// 没有 i d和 name 属性，设置会出警告
  import { defineComponent } from 'vue'
  // import { ElColorPicker } from 'element-plus'
  // 引入组件需要的属性 引入表单子控件的管理类
  import { itemProps, itemController } from '../map'

  export default defineComponent({
    name: 'nf-el-form-item-color',
    inheritAttrs: false,
    components: {
      // ElColorPicker
    },
    props: {
      modelValue: [String],
      ...itemProps // 基础属性
    },
    emits: ['update:modelValue'],
    setup (props, context) {
      return {
        ...itemController(props, context.emit) // value、mySubmit
      }
    }
  })
</script>
